export const SIZE_GUIDE_TITLE_LP = 'Bien choisir sa taille';
export const SIZE_GUIDE_TITLE_POPUP = 'Tableau de mensurations';
